import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import SoftAvatar from "components/SoftAvatar";
import userImage from "assets/images/illustrations/user.png";
import SoftButton from "components/SoftButton";
import { ApiResponse } from "model/apiResponseModel";
import api from "api/api";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SoftBadge from "components/SoftBadge";
import { convertSecondsToHoursLive } from "helpers/logMessages";
import { Link } from "react-router-dom";
import SearchField from "components/SearchField";
import { Avatar, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ConfirmDialog from "layouts/leaderboard/components/ConfirmDialog";
import DeleteTableButton from "components/DeleteTableButton";

export default function Levels() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteLevelId, setDeleteLevelId] = useState("");
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  
    const handleSearch = () => {
        if (searchQuery != "") {
           setCurrentPage(1);
           fetchLevels(1, searchQuery);
        }
    };

    const handleClearSearch = () => {
        if (searchQuery != "") {
            setCurrentPage(1);
            setSearchQuery("");
            fetchLevels(1, "");
        }
    };

    const isAddOrEdit = location.pathname.startsWith("/levels/add") || location.pathname.startsWith("/levels/edit");
    const isEdit = location.pathname.startsWith("/levels/edit");

  const fetchLevels = async (page = 1, search) => {
    try {
      setIsLoading(true);
      let postData = {
        limit,
        page,
      };

      if (search && search.trim() !== "") {
        postData.search = search.trim();
      }

      const response = await api.getLevels(postData);
      console.log(response);
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        setColumns([
          { name: "level Number", align: "center" },
          { name: "title", align: "left" },
          { name: "description", align: "center" },
          { name: "points Required", align: "center" },
          { name: "tier", align: "center" },
          { name: "status", align: "center" },
          { name: "actions", align: "center" },
        ]);

        setRows(
          response.data.levels.map((item) => ({
            linkPath: `/levels`,
             "level Number": (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.level_number}
              </SoftTypography>
            ),
            title: (
              <SoftBox display="flex" alignItems="center" px={1} pb={0.5}>
                <SoftBox display="flex" flexDirection="column" ml={2}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {item.title}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            ),
            "description": (
              <SoftTypography 
                variant="caption" 
                color="secondary" 
                fontWeight="medium"
                sx={{ 
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  minHeight: '40px',
                  maxWidth: "250px",
                }}
              >
                {item.description}
              </SoftTypography>
            ),
            "points Required": (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {item.xp_required}
              </SoftTypography>
            ),
            "tier": (
                <SoftTypography
                    variant="caption"
                    fontWeight="medium"
                    style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: item?.tier?.color,
                    }}
                >
                    {item?.tier?.icon && (
                    <Avatar
                        src={item.tier.icon}
                        alt={item?.tier?.name}
                        sx={{ width: 18, height: 18 }}
                    />
                    )}
                    {item?.tier?.name}
                </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  item.status === "active"
                    ? "Active"
                    : "Inactive"
                }
                color={
                  item.status === "active"
                    ? "success"
                    : "warning"
                }
                size="xs"
              />
            ),
            actions: (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <SoftTypography
                    component={Link}
                    to={`/levels/edit/?levelId=${item?._id}`}
                    variant="caption"
                    color="secondary"
                    fontWeight="medium"
                    sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        minHeight: '40px'
                    }}
                >
                 Edit
                </SoftTypography>
                <DeleteTableButton
                  onClick={() => {
                    setDeleteLevelId(item?._id);
                    setIsOpenDeleteDialog(true);
                  }}
                />
              </Box>
            ),
          }))
        );
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.error("Error fetching levels:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );

    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchLevels(currentPage, searchQuery);
    }
  }, [currentPage, navigate, searchQuery]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    // console.log(page);
    fetchLevels(page, searchQuery);
  };

  const handleCloseDeleteDialog = () => {
    setIsOpenDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      const response = await api.deleteLevel({ levelId: deleteLevelId });
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        setIsOpenDeleteDialog(false);
        window.location.href = "/levels";
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error deleting level:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isAddOrEdit ? (<Outlet /> ) : (
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6" width="20%">
                Levels
              </SoftTypography>
              <SoftBox display="flex" alignItems="center" gap={2}>
                <SearchField
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onSearch={handleSearch}
                onClear={handleClearSearch}
                />
    
                {/* ➕ Add Button */}
                <SoftButton
                variant="gradient"
                color="info"
                startIcon={<AddIcon />}
                onClick={() => navigate("/levels/add")}
                >
                    Add
                </SoftButton>
            </SoftBox>
              {/* <ProjectFilter status={status} setStatus={setStatus} /> */}
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              {isLoading ? (
                <SoftBox
                  display="flex"
                  height="500px"
                  justifyContent="center"
                  alignItems="center"
                  p={3}
                >
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    Loading...
                  </SoftTypography>
                </SoftBox>
              ) : rows.length > 0 ? (
                <Table columns={columns} rows={rows} />
              ) : (
                <SoftBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <SoftTypography variant="subtitle1" color="textSecondary">
                    No Levels Data Found
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
            <SoftBox display="flex" alignItems="center" justifyContent="center" py={2}>
              {/* Previous Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
                sx={{ mx: 1 }}
              >
                Previous
              </SoftButton>

              <SoftButton
                key={currentPage}
                variant="contained"
                color="primary"
                // onClick={() => handlePageClick(pageNumber)}
                sx={{ mx: 0.5 }}
              >
                {currentPage}
              </SoftButton>

              {/* Next Button */}
              <SoftButton
                variant="outlined"
                color="primary"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                sx={{ mx: 1 }}
              >
                Next
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </SoftBox>
      )}
      <ConfirmDialog
        isOpen={isOpenDeleteDialog}
        handleClose={handleCloseDeleteDialog}
        handleConfirm={handleConfirmDelete}
        isLoading={isDeleting}
        title="Are you sure you want to delete this level completely?"
        actionText="Yes, Delete"
      />
      <Footer />
    </DashboardLayout>
  );
}
